import { trackProductEvent } from "./track";

const getBucket = (name, value) => {
  if (name === "CLS") {
    if (value <= 0.1) return "good";
    if (value <= 0.25) return "needs_improvement";
    return "poor";
  }
  if (name === "LCP") {
    if (value <= 2500) return "good";
    if (value <= 4000) return "needs_improvement";
    return "poor";
  }
  if (name === "INP") {
    if (value <= 200) return "good";
    if (value <= 500) return "needs_improvement";
    return "poor";
  }
  if (name === "FID") {
    if (value <= 100) return "good";
    if (value <= 300) return "needs_improvement";
    return "poor";
  }
  if (name === "TTFB") {
    if (value <= 800) return "good";
    if (value <= 1800) return "needs_improvement";
    return "poor";
  }
  if (name === "FCP") {
    if (value <= 1800) return "good";
    if (value <= 3000) return "needs_improvement";
    return "poor";
  }
  return "unknown";
};

export const flushWebVitals = (user) => {
  if (typeof window === "undefined") return;
  const queue = window.__webVitals || [];
  if (!queue.length) return;
  window.__webVitals = [];

  queue.forEach((metric) => {
    if (!metric?.name) return;
    const unit = metric.name === "CLS" ? "score" : "ms";
    trackProductEvent(
      "performance_metric",
      {
        name: metric.name,
        value: Math.round(metric.value * 1000) / 1000,
        unit,
        bucket: getBucket(metric.name, metric.value),
        page: window.location.pathname,
      },
      user
    );
  });
};
